"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Requests/KeywordChip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);






/* "↰ FORMS": a keyword with an open request, on an inbox row, in the chat
 * header and on the request card. */
const KeywordChip = ({ keyword, className }) => (
  _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'keyword-chip', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    , _react2.default.createElement('svg', {
      width: 12,
      height: 12,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}

      , _react2.default.createElement('path', { d: "M9 14L4 9l5-5"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} )
      , _react2.default.createElement('path', { d: "M20 20v-7a4 4 0 00-4-4H4"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} )
    )
    ,  keyword 
  )
)

exports. default = _react.memo.call(void 0, KeywordChip)
